import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { JobList } from "components/Public/JobList";
import {useGetPublicJobsQuery} from "store/services/publicApi";

const Jobs = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialQuery = queryParams.get("query") || "";
    const initialPage = parseInt(queryParams.get("page") || "1");

    const [searchTerm, setSearchTerm] = useState(initialQuery);
    const [debouncedSearch, setDebouncedSearch] = useState(initialQuery);
    const [currentPage, setCurrentPage] = useState(initialPage);
    const jobsPerPage = 9;

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchTerm);
            setCurrentPage(1); // Reset to first page on new search
        }, 500);
        return () => clearTimeout(timer);
    }, [searchTerm]);

    const skip = (currentPage - 1) * jobsPerPage;

    const { data, isLoading, error } = useGetPublicJobsQuery({
        searchText: debouncedSearch || undefined,
        skip: skip,
    });
    const {totalCount, jobs} = data || {totalCount: 0, jobs: []};

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        const params = new URLSearchParams(location.search);
        if (page > 1) {
            params.set('page', page.toString());
        } else {
            params.delete('page');
        }
        if (debouncedSearch) {
            params.set('query', debouncedSearch);
        }
        const newUrl = `${location.pathname}${params.toString() ? '?' + params.toString() : ''}`;
        window.history.replaceState({}, '', newUrl);
    };

    return (
        <div className="public-jobs-page">
            <section className="oec-jobs-hero">
                <div className="oec-section-inner">
                    <h1>Power Your <span>Career</span> in the Energy Sector</h1>
                    <p>Discover opportunities that align with your skills and drive the future of energy.</p>
                    <form className="oec-jobs-search" onSubmit={(event) => event.preventDefault()}>
                        <i className="fas fa-search"/>
                        <input
                            type="search"
                            placeholder="Job title, or keyword..."
                            value={searchTerm}
                            onChange={(event) => setSearchTerm(event.target.value)}
                            aria-label="Search jobs"
                        />
                        <button className="oec-search-btn" type="submit">Search</button>
                    </form>
                </div>
            </section>

            <section className="oec-section">
                <JobList
                    jobs={jobs}
                    isLoading={isLoading}
                    error={error}
                    totalCount={totalCount}
                    itemsPerPage={jobsPerPage}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                    emptyMessage="No jobs match your search"
                    showPagination={true}
                />
            </section>
        </div>
    );
};

export default Jobs;
